import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthenticationService } from "../services/authentication.service";
import { AuthService } from "@auth0/auth0-angular";
import { Router } from "@angular/router";

@Injectable()
export class JWTErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private snackbar: MatSnackBar,
    private openIdAuth: AuthService,
    private router: Router 
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        let lastRoute = localStorage.getItem('lastVisitedRoute') || '';
        let isDesktopApp = lastRoute.includes('desktopapp');
        if (err.status === 401) {
          const currentUrl = this.router.url;
          // auto logout if 401 response returned from api
          if (this.authenticationService.loggedIn()) {
            this.snackbar.open("Session Expired. Please Login Again.", "Ok");
            if (localStorage.getItem("authenticationType") == "4") {
              this.authenticationService.logout(isDesktopApp, isDesktopApp);
            } else {
              setTimeout(() => {
                this.authenticationService.logout(isDesktopApp, isDesktopApp);
              }, 3000);
            }
          }
          const error = err.error?.message || err.statusText;
          return throwError(() => error);
        }
        if (err.status === 403 && !request.url.includes("ConcurrentUsers")) {
          const currentUrl = this.router.url;
          if (this.authenticationService.loggedIn()) {
            this.snackbar.open(
              "Error while validating user. Please login again.",
              "Ok"
            );

            setTimeout(() => {
              this.authenticationService.logout(isDesktopApp, isDesktopApp);
            }, 3000);
          }
        }

        return throwError(() => err);
      })
    );
  }
}
